export default __webpack_public_path__ + "static/media/SplashScreen.e3030f2f.png";